import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth }    from './hooks/useAuth';
import LandingPage    from './pages/LandingPage';
import ProfilePage    from './pages/ProfilePage';
import PrivacyPage    from './pages/PrivacyPage';
import TermsPage      from './pages/TermsPage';
import VroomkiPage    from './pages/VroomkiPage';
import LegalModals    from './components/LegalModals';

// ── /register?ref=KOD → przekieruj na /?ref=KOD&openAuth=1 ────────────────
function RegisterRedirect() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const refCode = searchParams.get('ref') ?? '';

  useEffect(() => {
    navigate(`/?ref=${refCode}&openAuth=1`, { replace: true });
  }, [navigate, refCode]);

  return null;
}

/** Normalizacja ścieżki (bez końcowego /), żeby "/" i "/privacy/" były przewidywalne. */
function normalizedPath(pathname) {
  if (!pathname || pathname === '/') return '/';
  return pathname.replace(/\/+$/, '') || '/';
}

export default function App() {
  const location = useLocation();
  const { user, login, logout } = useAuth();
  const [showTerms,   setShowTerms]   = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  useEffect(() => {
    const path = normalizedPath(location.pathname);
    if (path !== '/') return;
    const hasVisited = sessionStorage.getItem('vroom_visited');
    if (!hasVisited) {
      fetch('https://v-room.app/counter.php')
        .then(() => sessionStorage.setItem('vroom_visited', 'true'))
        .catch(() => {});
    }
    return undefined;
  }, [location.pathname]);

  return (
    <>
      <Routes>
        {/* Konkretne ścieżki przed "/" i przed "*", żeby nic nie przejęło wildcardem */}
        {/* /register?ref=KOD → automatyczny redirect */}
        <Route path="/register" element={<RegisterRedirect />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/privacy/" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/terms/" element={<TermsPage />} />
        <Route path="/vroomki/:id" element={<VroomkiPage />} />
        <Route path="/vroomki/:id/" element={<VroomkiPage />} />
        <Route
          path="/profile"
          element={
            user
              ? <ProfilePage user={user} onLogout={logout} />
              : <Navigate to="/" replace />
          }
        />
        <Route
          path="/"
          element={
            <LandingPage
              user={user}
              onLogin={login}
              onShowTerms={() => setShowTerms(true)}
              onShowPrivacy={() => setShowPrivacy(true)}
            />
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <LegalModals
        showTerms={showTerms}
        showPrivacy={showPrivacy}
        onCloseTerms={() => setShowTerms(false)}
        onClosePrivacy={() => setShowPrivacy(false)}
      />
    </>
  );
}
